module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-book-detail/right-arrow-light-2f08a2ae5a7fd9d25a9e3f17c56186bf.svg";